const ORDER = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
const FULL: Record<string, string> = {
  понедельник: 'Пн',
  вторник: 'Вт',
  среда: 'Ср',
  четверг: 'Чт',
  пятница: 'Пт',
  суббота: 'Сб',
  воскресенье: 'Вс',
};

/**
 * Сервер отдаёт по строке на день («понедельник: 09:00–21:00»). Для экрана
 * склеиваем подряд идущие дни с одинаковым временем: «Пн–Сб: 09:00–21:00».
 */
export function compactHours(lines: string[]): string[] {
  const rows: {day: string; value: string}[] = [];
  for (const line of lines) {
    const [rawDay = '', ...rest] = line.split(':');
    const key = rawDay.trim().toLowerCase();
    const day = FULL[key] ?? (ORDER.find((d) => d.toLowerCase() === key) ?? null);
    if (!day) return lines;
    rows.push({day, value: rest.join(':').trim()});
  }
  rows.sort((a, b) => ORDER.indexOf(a.day) - ORDER.indexOf(b.day));
  const out: string[] = [];
  let i = 0;
  while (i < rows.length) {
    let j = i;
    while (j + 1 < rows.length && rows[j + 1]!.value === rows[i]!.value) j += 1;
    const from = rows[i]!.day;
    const to = rows[j]!.day;
    out.push(`${i === j ? from : j === i + 1 ? `${from}, ${to}` : `${from}–${to}`}: ${rows[i]!.value}`);
    i = j + 1;
  }
  return out;
}
